export default __webpack_public_path__ + "static/media/Beard_11_C3.33426643.svg";